import Vue from 'vue';

const requireComponent = require.context('.', false, /\.vue$/);

requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    const componentName = fileName
        // remove "./" from the beginning
        .replace(/^\.\//, '')
        // remove file extension from the end
        .replace(/\.\w+$/, '');
    Vue.component(componentName, componentConfig.default || componentConfig);
});
